import React from 'react';
import Layout from '../components/Layout';
import Section from '../components/Section';
import Head from '../components/head';
import OpenGraphTitle from '../components/OpenGraphTitle';
import OpenGraphDescription from '../components/OpenGraphDescription';
import { FranchiseeProvider } from '../context/Franchisee';
import Link from 'next/link';
import { HomeDifferenceSection } from '../components/Sections/HomeDifferenceSection';
import ContactUs from '../components/ContactUs';
import { Col, Row } from "react-bootstrap";


interface WhyTwoMaidsPageProps {
  /* add why two maids page props here */
}

const WhyTwoMaids: React.FC<WhyTwoMaidsPageProps> = () => (
  <div className="why-two-maids-container">
    <FranchiseeProvider>
      <Layout alternateFooter>
        <Head
          slug='why-two-maids'
          title='Why Hire Two Maids?'
          description="Your home will receive the highest level of care from Two Maids' fully licensed, bonded, and insured cleaning teams. We offer one time cleans and recurring service which can be priced by the clean or by the hour."
        />
        <OpenGraphTitle title='Why Hire Two Maids?' />
        <OpenGraphDescription>
          Your home will receive the highest level of care from Two Maids' fully licensed, bonded, and insured cleaning teams. We offer one time cleans and recurring service which can be priced by the clean or by the hour. 
        </OpenGraphDescription>
        {/* <div className='top-background-dots'></div> */}
        <div className="why-hire-us-jumbotron mb-5">
          <Section>
            <h1>Why Choose Two Maids: <br/> The Difference that Shines.</h1>
            <h2>Powered by Caring; Driven by Satisfaction</h2>
            <p>
              At Two Maids, our mission goes beyond clean homes — it’s about creating comfort, connection, and 
              care. We proudly support the families we serve and the team members who serve them, knowing that 
              a strong community is built on both. Together, we shine brighter.
            </p>
        </Section>
        </div>
        <Section>
          <div>
            <div className='people-are-our-product-section mb-5'>
              <div>
                <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1755888156/franchising-next/we_care_graphic.webp" alt="We Care" />
              </div>
              <div>
                <h2>
                  People are our Product:
                </h2>
                <h3>
                  1. We care for each other:
                </h3>
                <p>
                  We are a people-first-business, which means everything begins with us.
                  When we take care of ourselves and support one another, we
                  strengthen our business - and that naturally leads to taking better care
                  of our customers. Success starts here: take care of yourself and take
                  care of each other.
                </p>

                <h3>
                  2. We care for our customers:
                </h3>
                <p>
                  Our business centers around the work we do for our customers and
                  the impression we make. When we establish strong, trusting
                  relationships with our customers, they come to depend on us. 
                  If our professional house cleaners create relationships with our
                  customers, they can build repeat business that helps them create
                  steady income.
                </p>

                <h3>
                  3. We care for our work:
                </h3>
                <p>
                  Time and again, we hear from our cleaners that pride in their work was
                  a driving force in their job satisfaction. We at Two Maids love coming
                  into the messiest of homes and leaving them shining just a few hours
                  later. The little things matter, and we take pride in every little thing.
                </p>
              </div>
            </div>
            <div className="why-two-maids-section">
              <h2>Maid to Shine:</h2>
              <h3>Recognition for our teams. Outstanding service for you.</h3>
              <div className='d-flex mb-5'>
                <div className='why-two-maids-video-container'>
                  <div>
                    <p>
                      At Two Maids, we believe in celebrating what matters most -
                      people. When customers share kind words, glowing reviews,
                      or thoughtful compliments, it fuels something bigger. Our
                      teams are rewarded with special incentives, benefits, and
                      bonuses - a heartfelt thank-you for their hard work and
                      dedication. This ongoing recognition nurtures a happy,
                      motivated team that's inspired to deliver the exceptional care
                      your home deserves.
                    </p>
                    <p>
                      Our customers aren’t just buying a clean home; they’re buying
                      trust, consistency, and peace of mind—and all of that comes
                      directly from the individuals doing the work.
                    </p>
                    <p>
                      That's why we invest so much in hiring the right people,
                      training them well, and creating a culture where they feel
                      valued, because when our people succeed, our product shines.
                    </p>
                  </div>
                  <iframe src="https://player.vimeo.com/video/1097543241?h=250bcf0ede&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="500" height="281" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="Powered By Caring - Two Maids"></iframe>
                </div>
              </div>
            </div>
            <div className="why-two-maids-section pt-5 mb-5">
            <h2>Maid to Give:</h2>
            <h3>Every Location. Every Community. One Day of Giving</h3>
            <div className='d-flex mb-5'>
              <div className='why-two-maids-video-container'>
                <iframe src="https://player.vimeo.com/video/1168622077?h=250bcf0ede&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" width="500" height="281" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" title="Powered By Caring - Two Maids"></iframe>
                <div>
                  <p>
                    At Two Maids, our heart doesn't just beat at our corporate headquarters, 
                    it beats in every neighborhood, on every street corner, and in every community 
                    where our doors are open.
                  </p>
                  <p>
                    When you choose Two Maids, we get to give more.
                  </p>
                  <p>
                    Together, we make a bigger impact.
                  </p>
                  <p>
                    Maid to Give™
                  </p>
                  <p>
                    A national day of service, every first Saturday in April.
                  </p>
                  <p>
                    On this day, Two Maids teams will come together across the nation for one 
                    incredible day of giving, performing local acts of service, community partnerships, 
                    and purposeful generosity to give back to the communities where we clean, and where 
                    we live.
                  </p>
                </div>
              </div>
            </div>
            <img src="https://res.cloudinary.com/twomaidsengi/image/upload/v1782239395/hubsite-reskin/Maid_to_Give_Banner.webp" alt="Maid to Give" />
          </div>
          </div>
        </Section>
        <HomeDifferenceSection />
        <ContactUs
          title="Ready to Experience a Clean That Cares?"
          className="contact-us-flex"
          buttons={
            <Row className="d-flex justify-content-center">
              <Col md={"auto"} className="mb-3">
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">BOOK YOUR CLEANING</a>
                </Link>
              </Col>
              <Col md={"auto"}>
                <Link href={process.env.SALES_FUNNEL_URL}>
                  <a className="contact-us-button">CALCULATE YOUR PRICE</a>
                </Link>
              </Col>
            </Row>
          }
        >
        <p>
          Let us show you what makes Two Maids
          different. Book your personalized cleaning
          service today and enjoy a home that’s spotless,
          peaceful, and made to shine.
        </p>
      </ContactUs>
      </Layout>
    </FranchiseeProvider>
  </div>
);

export default WhyTwoMaids;
